import React from "react"
import BlockWrapper from "@yumgmbh/gatsby-theme-yum-components/src/components/technical/BlockWrapper"
import Richtext from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Richtext"

const RegionsBlock = ({ block }) => {
  return (
    <BlockWrapper
      block={block}
      blockWidth="container"
      showHeadline="true"
      blockWidth="content"
      className="bg-gray-100"
    >
      <div className="mt-8">
        <Richtext className="text-gray-500" text={block.text} />
        <div className="p-4 mt-4 bg-white rounded-xl">
          <form>
            <div className="flex flex-row flex-wrap -mx-2 -mb-4 lg:flex-nowrap">
              <div className="w-full px-2 mb-4 sm:w-3/5 md:w-1/2">
                <select
                  className="inline-block w-full px-4 py-3 text-base bg-white border border-gray-300 rounded-xl"
                  name="region"
                  id="region-select"
                >
                  <option className="inline-block text-base" value="">
                    Regionenauswahl
                  </option>
                  <option className="inline-block text-base" value="osnabrueck">
                    Osnabrück/Ostwestfalen-Lippe
                  </option>
                  <option className="inline-block text-base" value="regensburg">
                    Regensburg - Oberpfalz/Niederbayern
                  </option>
                </select>
              </div>
              <div className="w-full px-2 mb-4 sm:w-2/5 md:w-1/2 lg:w-auto">
                <input
                  className="w-full px-4 py-2 border border-gray-300 rounded-xl"
                  name="zip-code"
                  id="zip-code"
                  type="text"
                  placeholder="Ihre Postleitzahl"
                />
              </div>
              <div className="w-full px-2 mb-4 lg:w-auto whitespace-nowrap">
                <button className="mr-4 btn btn-primary whitespace-nowrap">
                  Region suchen
                </button>
                <button className="border-gray-300 btn btn-secondary-white whitespace-nowrap">
                  Löschen
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </BlockWrapper>
  )
}

export default RegionsBlock
